import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { NavController } from '@ionic/angular';
import { NavService } from '../services/nav.service';
import { StoreService } from '../services/store.service';
import { Ui } from '../services/ui.service';
import { CandoGuard } from './cando.guard';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private can: CandoGuard , private user: UserService, private router: NavController,
    private navService: NavService,
    private ui: Ui,
    private store: StoreService) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    console.log('AUTH ACTIONS::: ');
    this.ui.activatedServices = this.ui.services.filter(e => !e.authorizations || e.authorizations.length === 0);
    this.navService.redirectUrl = next.url[0].path;
    if (this.navService.redirectUrl.match(/403/)) {
      this.navService.redirectUrl = '';
      return false;
    }
    if (this.navService.redirectUrl.match(/login/)) {
      this.navService.redirectUrl = '';
    }
    return this.store.load().then(() => {
      return this.user.me().toPromise().then(r => {
        this.ui.activatedServices = this.ui.services;
        return true;
      }).catch(err => {
        // this.router.navigateRoot('/login');
        return true;
      });
    });
  }
}
